import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Image, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
  SCREEN_NORMAL,
  SCREEN_WIDE,
} from '../../../config/constants';
import type { MediaReferenceField } from '../../../types/uncinc_profile/helpers/media';

export interface ImageSliderItemProps {
  item: ImmutableEntity<MediaReferenceField<'image'>>;
  isFullScreen?: boolean;
  lazyload?: boolean;
}

const ImageSliderItem: React.FC<ImageSliderItemProps> = ({
  item,
  isFullScreen,
  lazyload = true,
}) => {
  const {
    title,
    styles,
    alt,
    entity,
  } = item.toJS();

  const caption = entity.field_caption[0]?.value;
  const body = entity.field_body[0]?.processed;
  const imageAlt = alt || caption || title;

  return (
    <figure key={`image-slide-${title}`} className="ImageSlider__Item">
      <div className="ImageSlider__Item__image_wrapper">
        <Image
          lazyload={lazyload}
          // @ts-expect-error
          includeWebP
          alt={imageAlt}
          src={{
            [SCREEN_MOBILE]: styles.ratio_4_3_xs,
            [SCREEN_TABLET]: styles.ratio_4_3_sm,
            [SCREEN_NORMAL]: styles.ratio_4_3_md,
            [SCREEN_WIDE]: styles.ratio_4_3_xl,
          }}
        />
      </div>

      {(!isFullScreen && (caption || body)) && (
        <div className="ImageSlider__Item__content">
          <figcaption className="ImageSlider__Item__description">
            {caption && (
              <p className="ImageSlider__Item__caption">
                {caption}
              </p>
            )}

            {body && (
              <WysiwygField
                className="ImageSlider__Item__body"
                property="schema:text"
                html={body}
              />
            )}
          </figcaption>
        </div>
      )}
    </figure>
  );
};

export default ImageSliderItem;
